export default __webpack_public_path__ + "static/media/price_seal1.083554d0.png";